import { cn } from '../lib/utils';

const statusStyles = {
  pending: 'status-pending',
  confirmed: 'status-confirmed',
  rejected: 'status-rejected',
  cancelled: 'status-cancelled',
};

const statusLabels = {
  pending: 'Pending',
  confirmed: 'Confirmed',
  rejected: 'Rejected',
  cancelled: 'Cancelled',
};

export const StatusBadge = ({ status, className }) => {
  return (
    <span
      className={cn(
        'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium',
        statusStyles[status] || statusStyles.pending,
        className
      )}
      data-testid={`status-badge-${status}`}
    >
      {statusLabels[status] || status}
    </span>
  );
};

export const PaymentBadge = ({ type }) => {
  if (!type) return <span className="text-slate-400 text-xs">-</span>;
  
  return (
    <span
      className={cn(
        'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium',
        type === 'instant' ? 'bg-blue-100 text-blue-800 border border-blue-200' : 'bg-purple-100 text-purple-800 border border-purple-200'
      )}
      data-testid={`payment-badge-${type}`}
    >
      {type === 'instant' ? 'Instant Payment' : 'Credit'}
    </span>
  );
};

export const RouteBadge = ({ route }) => {
  const routeLabels = {
    luxor_to_aswan: 'Luxor → Aswan',
    aswan_to_luxor: 'Aswan → Luxor',
  };
  
  return (
    <span className="badge-route" data-testid="route-badge">
      {routeLabels[route] || route}
    </span>
  );
};

const invoiceStatusStyles = {
  draft: 'bg-slate-100 text-slate-700 border border-slate-200',
  issued: 'bg-blue-100 text-blue-800 border border-blue-200',
  partially_paid: 'bg-amber-100 text-amber-800 border border-amber-200',
  paid: 'bg-green-100 text-green-800 border border-green-200',
  overdue: 'bg-red-100 text-red-800 border border-red-200',
  cancelled: 'bg-slate-100 text-slate-500 border border-slate-200',
};

const invoiceStatusLabels = {
  draft: 'Draft',
  issued: 'Issued',
  partially_paid: 'Partially Paid',
  paid: 'Paid',
  overdue: 'Overdue',
  cancelled: 'Cancelled',
};

export const InvoiceStatusBadge = ({ status }) => {
  return (
    <span
      className={cn(
        'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium',
        invoiceStatusStyles[status] || invoiceStatusStyles.draft
      )}
      data-testid={`invoice-status-badge-${status}`}
    >
      {invoiceStatusLabels[status] || status}
    </span>
  );
};

const agentStatusStyles = {
  pending: 'bg-amber-100 text-amber-800 border border-amber-200',
  active: 'bg-green-100 text-green-800 border border-green-200',
  suspended: 'bg-red-100 text-red-800 border border-red-200',
};

const agentStatusLabels = {
  pending: 'Pending Approval',
  active: 'Active',
  suspended: 'Suspended',
};

export const AgentStatusBadge = ({ status }) => {
  return (
    <span
      className={cn(
        'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium',
        agentStatusStyles[status] || agentStatusStyles.pending
      )}
      data-testid={`agent-status-badge-${status}`}
    >
      {agentStatusLabels[status] || status}
    </span>
  );
};
